import React from "react";
import { FaInstagram, FaTwitter, FaLinkedin, FaGithub, FaDribbble } from "react-icons/fa";
import Fade from "react-reveal/Fade";
import Header from "../Header/Header";
import img1 from "../../Assets/team/img1.jpeg"
import img2 from "../../Assets/team/img2.jpeg"
import img3 from "../../Assets/team/img3.jpeg"
import img4 from "../../Assets/team/img4.jpeg"
import img5 from "../../Assets/team/img5.jpeg"
import img6 from "../../Assets/team/img6.jpeg"

const About = (props) => {

  const {
    setQuestions,
    theme
  } = props;

  const stylesL =theme? require("./AboutLight.module.css"):require("./About.module.css");

  return (
    <div className={stylesL.Main}>
      <Header  setQuestions={setQuestions}/>
      <div className={stylesL.majorContainer}>
        <div className={stylesL.content}>
          <Fade>
            <div className={stylesL.Description}>
              <h1>ABOUT US</h1>
              <p>
                 Tired of marking and framing questions from your materials every time? Say goodbye to all the hassles. Upload your study materials on Q-Gen and generate  smart quizzes to evaluate yourself. Developed by the team of Microsoft Learn Student Ambassador SRM.
              </p>
            </div>
          </Fade>

          <div className="Columns"></div>
          <div className={stylesL.Socials}>
            <p>FIND US</p>
            <a href="https://www.instagram.com/mlsa.srm/" target="_blank" rel="noopener noreferrer">
              <i className={stylesL.icons}>
                <FaInstagram />
              </i>
            </a>
            <a href="https://twitter.com/mlsasrm" target="_blank" rel="noopener noreferrer">
              <i className={stylesL.icons}>
                <FaTwitter />
              </i>
            </a>
            <a href="https://www.linkedin.com/company/mlsa-srm/mycompany/" target="_blank" rel="noopener noreferrer">
              <i className={stylesL.icons}>
                <FaLinkedin />
              </i>
            </a>
          </div>
        </div>
        <div className={stylesL.teamM}>
          <div>
              <img src={img1} />
              <div>
                <h2>
                  Samaresh Samanta
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/samaresh-samanta-255a5b1b7/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/nectro" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
          </div>
          <div>
              <img src={img2} />
              <div>
                <h2>
                  Tabrez Mohammed
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/tabrez-mohammed-1773781b3/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/lowjunkie" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
          </div>
          <div>
              <img src={img4} />
              <div>
                <h2>
                  Nirbyoleek Das
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/nirbyoleek-das-1421161b9/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/Nirbyoleek" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
          </div>
          <div>
              <img src={img5} />
              <div>
                <h2>
                  Aryan Nikhil
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/aryan-nikhil-962666190/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/Violent-Idiot" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
          </div>
          <div>
              <img src={img6} />
              <div>
                <h2>
                  Samarpan Das
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/samarpan-das" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/SamarpanDas" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
          </div>
          <div>
              <img src={img3} />
              <div>
                <h2>
                  S Ashwin Raja
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/ash-raja-68950918b/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://dribbble.com/AshRaja941" target="_blank" rel="noopener noreferrer">
                    <FaDribbble />
                  </a>
                </p>
              </div>
          </div>
        </div>
        <div className={stylesL.team}>
          <div>
            <span>
              <img src={img1} />
              <div>
                <h2>
                  Samaresh Samanta
                </h2>
                <p>
                  <a href="https://www.linkedin.com/in/samaresh-samanta-255a5b1b7/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/nectro" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
            </span>
          </div>
          <div>
            <span>
              <img src={img2} />
              <div>
                <h2>
                  Tabrez Mohammed
                </h2>
                <p>
                <a href="https://www.linkedin.com/in/tabrez-mohammed-1773781b3/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/lowjunkie" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
            </span>
            <span>
              <img src={img4} />
              <div>
                <h2>
                  Nirbyoleek Das
                </h2>
                <p>
                <a href="https://www.linkedin.com/in/nirbyoleek-das-1421161b9/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/Nirbyoleek" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
            </span>
          </div>
          <div>
            <span>
              <img src={img5} />
              <div>
                <h2>
                  Aryan Nikhil
                </h2>
                <p>
                <a href="https://www.linkedin.com/in/aryan-nikhil-962666190/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/Violent-Idiot" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
            </span>
            <span>
              <img src={img6} />
              <div>
                <h2>
                  Samarpan Das
                </h2>
                <p>
                <a href="https://www.linkedin.com/in/samarpan-das" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://github.com/SamarpanDas" target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </p>
              </div>
            </span>
            <span>
              <img src={img3} />
              <div>
                <h2>
                  S Ashwin Raja
                </h2>
                <p>
                <a href="https://www.linkedin.com/in/ash-raja-68950918b/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://dribbble.com/AshRaja941" target="_blank" rel="noopener noreferrer">
                    <FaDribbble />
                  </a>
                </p>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
